var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c(
        "history-wrapper",
        {
          attrs: {
            overflowVisible: "",
            defaultOpened: "",
            title: _vm.$t("diseases"),
            hideTitleOnOpen: ""
          }
        },
        [
          _c("history-diseases-section", {
            on: {
              anyItemSelected: function($event) {
                _vm.diseaseSelected = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "history-wrapper",
        {
          attrs: {
            overflowVisible: "",
            defaultOpened: "",
            title: _vm.$t("chrondiseases"),
            hideTitleOnOpen: ""
          }
        },
        [
          _c("history-chrondiseases-section", {
            on: {
              anyItemSelected: function($event) {
                _vm.chronDiseaseSelected = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "history-wrapper",
        {
          attrs: {
            overflowVisible: "",
            defaultOpened: "",
            title: _vm.$t("allergies"),
            hideTitleOnOpen: ""
          }
        },
        [
          _c("history-med-allergies-section", {
            on: {
              anyItemSelected: function($event) {
                _vm.medAllergiesSelected = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "history-wrapper",
        {
          attrs: {
            overflowVisible: "",
            defaultOpened: "",
            title: _vm.$t("otherAllergies"),
            hideTitleOnOpen: ""
          }
        },
        [
          _c("history-allergies-section", {
            on: {
              anyItemSelected: function($event) {
                _vm.allergiesSelected = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "history-wrapper",
        {
          attrs: {
            overflowVisible: "",
            defaultOpened: "",
            title: _vm.$t("currentMedication"),
            hideTitleOnOpen: ""
          }
        },
        [
          _c("history-medicines-section", {
            attrs: { hideReminderDialog: "" },
            on: {
              anyItemSelected: function($event) {
                _vm.medicinesSelected = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-card",
        [
          _c(
            "b-row",
            { staticClass: "mt-5", staticStyle: { gap: "1rem" } },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h4", { domProps: { innerHTML: _vm._s(_vm.$t("weight")) } })
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "2", cols: "6" } },
                [
                  _c("base-input", {
                    attrs: { placeholder: _vm.$t("weight") },
                    model: {
                      value: _vm.localizedPatientWeight,
                      callback: function($$v) {
                        _vm.localizedPatientWeight = $$v
                      },
                      expression: "localizedPatientWeight"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "1", cols: "4" } },
                [
                  _c("base-button", { on: { click: _vm.saveWeight } }, [
                    _vm._v(_vm._s(_vm.$t("save")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("back-button", {
                    staticClass: "mr-3",
                    attrs: { withoutArrow: "" }
                  }),
                  _vm._v(" "),
                  _c("base-button", { on: { click: _vm.checkHealthData } }, [
                    _vm._v(_vm._s(_vm.$t("continue")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d291344", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d291344","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/appointment-request/AppointmentRequestHistoryData.vue
// module id = 4137
// module chunks = 2